const PAGE_SIZE = 10;

const LIMIT = 2147483647;

const constants = {
    order: {
        ORDER_UPDATED:  "order-updated",
        HOST_ORDER_CANCELED: "host-order-canceled"
    }
 }

 
export { PAGE_SIZE, LIMIT, 
        constants }